import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import BoxIcon from "./box.svg";

export default function CouldntFind(props) {
  const [comment, setComment] = useState("");
  const [message, setMessge] = useState(false);

  async function submitComment(e) {
    e.preventDefault();
    const response = await fetch("https://api.apphud.com/gallery/apps", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ url: comment.replace(/ +/g, " ").trim() }),
    });
    const data = await response.json();
    if (data) {
      setComment("");
      setMessge(true);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      setMessge(false);
    }, 2000);
  }, [message]);
  return (
    <div className={styles.wrapper}>
      <BoxIcon className={styles.img} />
      <p>Couldn't find the app? Suggest an app</p>
      <form className={styles.root} onSubmit={submitComment}>
        <input
          type="url"
          pattern="https://.*"
          required
          className={styles.input}
          placeholder="App Store URL"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        <input type="submit" value="Send" className={styles.item} />
        {message && <span>Thank you! We will review your request!</span>}
      </form>
    </div>
  );
}
